import { render, staticRenderFns } from "./ShipmentTimeline.vue?vue&type=template&id=4fd3d71c&scoped=true"
import script from "./ShipmentTimeline.vue?vue&type=script&lang=js"
export * from "./ShipmentTimeline.vue?vue&type=script&lang=js"
import style0 from "./ShipmentTimeline.vue?vue&type=style&index=0&id=4fd3d71c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd3d71c",
  null
  
)

export default component.exports